<template>
  <div v-if="cart.itemTableLoading">
    <loading-component class="hidden-xs"></loading-component>
  </div>
  <table v-else class="table table-striped hidden-xs">
    <thead>
      <tr>
        <th>Product</th>
        <th>Price</th>
        <th>Qty</th>
        <th>Subtotal</th>
      </tr>
    </thead>
    <item-table-rows
      v-for="(cartItem, cartItemIndex) in cart.cartItems"
      :key="cartItemIndex"
      :cart-item-index="cartItemIndex"
      :cart-item="cartItem"
    ></item-table-rows>
  </table>
</template>

<script>
import { mapState } from "vuex";
import store from "../../store/stores";
import ItemTableRows from "./ItemTableRows.vue";
import LoadingComponent from "../checkout/components/elements/LoadingComponent.vue";

export default {
  name: "ItemTable",
  store,
  components: { ItemTableRows, LoadingComponent },
  computed: {
    ...mapState(["cart"]),
  },
};
</script>

<style scoped></style>
